import { RiCloseLine } from "react-icons/ri";
import styles from "./OrdersToolbar.module.css";

const OrdersActiveFilters = ({ filters, onClear, onReset, includeDummy, onToggleDummy }) => (
  <div className={styles.activeFilters} aria-label="Active order filters">
    <div className={styles.filterChips}>
      <label className={styles.dummyToggle}>
        <input
          type="checkbox"
          checked={includeDummy}
          onChange={onToggleDummy}
        />
        <span>Show dummy</span>
      </label>
      {filters.map((filter) => (
        <button
          key={filter.key}
          type="button"
          className={styles.filterChip}
          onClick={() => onClear(filter.key)}
          aria-label={`Remove ${filter.label} filter`}
        >
          {filter.label}
          <RiCloseLine aria-hidden="true" />
        </button>
      ))}
    </div>
    {!!filters.length && (
      <button
        type="button"
        className={styles.resetAction}
        onClick={onReset}
        aria-label="Reset all filters"
      >
        Reset all
      </button>
    )}
  </div>
);

export default OrdersActiveFilters;
